import { render, staticRenderFns } from "./ClientesCliente.vue?vue&type=template&id=648be142&scoped=true&"
import script from "./ClientesCliente.vue?vue&type=script&lang=js&"
export * from "./ClientesCliente.vue?vue&type=script&lang=js&"
import style0 from "./ClientesCliente.vue?vue&type=style&index=0&id=648be142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648be142",
  null
  
)

export default component.exports